import React, {useEffect, useState} from 'react'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {Col, Row, Modal, Button} from 'react-bootstrap'
// @ts-ignore
import BootstrapTable from 'react-bootstrap-table-next'
// @ts-ignore
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import {getFeatureConfigDeployments} from '../../../../_metronic/helpers/backend_helper'
import {AppFeatureConfigAuditHistoryListResponse, AppFeatureConfigAuditHistoryResponse} from '../../../../AUTO_GENERATED_TYPES'
import Moment from 'moment'

const DeploymentHistory: React.FC = () => {
  const [deploymentData, setDeploymentData] = useState<AppFeatureConfigAuditHistoryListResponse | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false)
  const [selectedRecord, setSelectedRecord] = useState<AppFeatureConfigAuditHistoryResponse | null>(null)
  // const [showRollbackModal, setShowRollbackModal] = useState<boolean>(false)
  // const [rollbackRecord, setRollbackRecord] = useState<AppFeatureConfigAuditHistoryResponse | null>(null)

  const {SearchBar} = Search

  const configBreadcrumbs: Array<PageLink> = [
    {
      title: 'Home /',
      path: '/dashboard/apps',
      isSeparator: false,
      isActive: false,
    },
  ]

  useEffect(() => {
    const fetchDeploymentHistory = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const response: AppFeatureConfigAuditHistoryListResponse = await getFeatureConfigDeployments()
        setDeploymentData(response)
      } catch (err: any) {
        console.error('Error fetching deployment history:', err)
        setError(err.message || 'Failed to fetch deployment history')
      } finally {
        setIsLoading(false)
      }
    }

    fetchDeploymentHistory()
  }, [])

  const handleShowDetails = (record: AppFeatureConfigAuditHistoryResponse) => {
    setSelectedRecord(record)
    setShowDetailsModal(true)
  }

  const handleCloseDetails = () => {
    setShowDetailsModal(false)
    setSelectedRecord(null)
  }

  // const handleShowRollback = (record: AppFeatureConfigAuditHistoryResponse) => {
  //   setRollbackRecord(record)
  //   setShowRollbackModal(true)
  // }

  // const handleCloseRollback = () => {
  //   setShowRollbackModal(false)
  //   setRollbackRecord(null)
  // }

  // const handleConfirmRollback = () => {
  //   // TODO: Implement rollback logic here
  //   console.log('Rollback confirmed for record:', rollbackRecord?.id)
    
  //   // Close the modal after confirmation
  //   handleCloseRollback()
  // }

  const columns = [
    {
      dataField: 'id',
      text: 'ID',
      sort: true,
      headerStyle: {width: '80px'},
    },
    {
      dataField: 'app_token',
      text: 'App Token',
      sort: true,
      headerStyle: {width: '120px'},
      formatter: (cell: string) => {
        if (!cell) return '-'
        return (
          <span className="text-truncate d-inline-block" style={{maxWidth: '100px'}} title={cell}>
            {cell}
          </span>
        )
      },
    },
    {
      dataField: 'app_name',
      text: 'App Name',
      sort: true,
      headerStyle: {width: '150px'},
      formatter: (cell: string) => cell || '-',
    },
    {
      dataField: 'operation_type',
      text: 'Operation Type',
      sort: true,
      headerStyle: {width: '150px'},
    },
    {
      dataField: 'operation_description',
      text: 'Description',
      sort: true,
      headerStyle: {width: '200px'},
      formatter: (cell: string) => cell || '-',
    },
    {
      dataField: 'user_username',
      text: 'User',
      sort: true,
      headerStyle: {width: '120px'},
      formatter: (cell: string) => cell || '-',
    },
    {
      dataField: 'created_at',
      text: 'Created At',
      sort: true,
      headerStyle: {width: '180px'},
      formatter: (cell: string) => Moment(cell).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      dataField: 'previous_schema_version',
      text: 'Previous Schema Version',
      sort: true,
      headerStyle: {width: '150px'},
      formatter: (cell: number) => cell || '-',
    },
    {
      dataField: 'new_schema_version',
      text: 'New Schema Version',
      sort: true,
      headerStyle: {width: '150px'},
      formatter: (cell: number) => cell || '-',
    },
    {
      dataField: 'source_system',
      text: 'Source System',
      sort: true,
      headerStyle: {width: '120px'},
      formatter: (cell: string) => cell || '-',
    },
    {
      dataField: 'backup_file_location',
      text: 'Backup Location',
      sort: false,
      headerStyle: {width: '200px'},
      formatter: (cell: string) => {
        if (!cell) return '-'
        return (
          <span className="text-truncate d-inline-block" style={{maxWidth: '180px'}} title={cell}>
            {cell}
          </span>
        )
      },
    },
    {
      dataField: 'actions',
      text: 'Actions',
      sort: false,
      headerStyle: {width: '150px'},
      formatter: (cell: any, row: AppFeatureConfigAuditHistoryResponse) => (
        <div className="d-flex gap-2">
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => handleShowDetails(row)}
          >
            Details
          </Button>
          {/* <Button
            variant="outline-danger"
            size="sm"
            onClick={() => handleShowRollback(row)}
          >
            Rollback
          </Button> */}
        </div>
      ),
    },
  ]

  if (error) {
    return (
      <>
        <PageTitle breadcrumbs={configBreadcrumbs}>Deployment History</PageTitle>
        <div className="alert alert-danger" role="alert">
          Error: {error}
        </div>
      </>
    )
  }

  return (
    <>
      <PageTitle breadcrumbs={configBreadcrumbs}>Deployment History</PageTitle>
      {!isLoading ? (
        <>
          <ToolkitProvider
            keyField="id"
            data={deploymentData?.audit_records || []}
            columns={columns}
            search
            bootstrap4
          >
            {(props: any) => (
              <div>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <p className="text-muted mb-0">
                      Total Records: {deploymentData?.total_count || 0}
                    </p>
                  </div>
                  <div>
                    <SearchBar {...props.searchProps} placeholder="Search deployments..." />
                  </div>
                </div>
                <Row>
                  <Col xl='12'>
                    {deploymentData?.audit_records && deploymentData.audit_records.length > 0 ? (
                      <BootstrapTable
                        {...props.baseProps}
                        keyField='id'
                        pagination={paginationFactory()}
                        bordered={true}
                        responsive
                        stripped
                        headerWrapperClasses={"header-class"}
                      />
                    ) : (
                      <div className="text-center py-5">
                        <p className="text-muted mb-0">No deployment history found</p>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            )}
          </ToolkitProvider>
        </>
      ) : (
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted mb-0">Loading deployment history...</p>
        </div>
      )}

      {/* Details Modal */}
      <Modal show={showDetailsModal} onHide={handleCloseDetails} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Deployment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRecord && (
            <div>
              <Row>
                <Col md={6}>
                  <h6>Basic Information</h6>
                  <table className="table table-borderless">
                                         <tbody>
                       <tr>
                         <td><strong>ID:</strong></td>
                         <td>{selectedRecord.id}</td>
                       </tr>
                       <tr>
                         <td><strong>App Token:</strong></td>
                         <td>{selectedRecord.app_token || '-'}</td>
                       </tr>
                       <tr>
                         <td><strong>App Name:</strong></td>
                         <td>{selectedRecord.app_name || '-'}</td>
                       </tr>
                       <tr>
                         <td><strong>Operation Type:</strong></td>
                         <td>{selectedRecord.operation_type}</td>
                       </tr>
                      <tr>
                        <td><strong>Description:</strong></td>
                        <td>{selectedRecord.operation_description || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>User:</strong></td>
                        <td>{selectedRecord.user_username || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>User ID:</strong></td>
                        <td>{selectedRecord.user_id || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Created At:</strong></td>
                        <td>{Moment(selectedRecord.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
                      </tr>
                      <tr>
                        <td><strong>Updated At:</strong></td>
                        <td>{Moment(selectedRecord.updated_at).format('YYYY-MM-DD HH:mm:ss')}</td>
                      </tr>
                      <tr>
                        <td><strong>Previous Schema Version:</strong></td>
                        <td>{selectedRecord.previous_schema_version || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>New Schema Version:</strong></td>
                        <td>{selectedRecord.new_schema_version || '-'}</td>
                      </tr>
                      <tr>
                        <td><strong>Source System:</strong></td>
                        <td>{selectedRecord.source_system || '-'}</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
                <Col md={6}>
                  <h6>Backup Information</h6>
                  <div className="mb-3">
                    <strong>Backup File Location:</strong>
                    <div className="mt-2">
                      {selectedRecord.backup_file_location ? (
                        <div className="bg-light p-2 rounded">
                          <code style={{fontSize: '12px', wordBreak: 'break-all'}}>
                            {selectedRecord.backup_file_location}
                          </code>
                        </div>
                      ) : (
                        <span className="text-muted">No backup file location</span>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDetails}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Rollback Confirmation Modal */}
      {/* <Modal show={showRollbackModal} onHide={handleCloseRollback} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Rollback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div className="mb-3">
              <i className="fas fa-exclamation-triangle text-warning" style={{fontSize: '3rem'}}></i>
            </div>
            <h5 className="text-danger mb-3">Warning: This operation cannot be undone!</h5>
            <p className="mb-3">
              You are about to rollback the configuration to a previous state. This action will:
            </p>
            <ul className="text-start mb-3">
              <li>Revert all changes made in this deployment</li>
              <li>Restore the previous schema version</li>
              <li>Restore the bacuup file</li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseRollback}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmRollback}>
            Confirm Rollback
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  )
}

export {DeploymentHistory} 